/**
 * Liga os serviços do núcleo (depósito dos quadros, controlador do loop,
 * pré-carregamento, atualização automática e link compartilhável) durante a
 * vida do App.
 */
import { useEffect } from 'react';
import { detectDeviceProfile } from '../goes/budget';
import { frameCache } from '../goes/frameCache';
import { startFrameStorage } from '../goes/frameStorage';
import { startUrlSync } from '../state/urlSync';
import { startAutoRefresh } from './autoRefresh';
import { startLoopController } from './controller';
import { startPreloader } from './preloader';
import { startStartupBehaviors } from './startup';

export function useCoreEngine(): void {
  useEffect(() => {
    // O depósito vem primeiro: o controlador espera a medição (disco ou RAM)
    // para o primeiro plano já sair com o orçamento certo.
    const stops = [
      startFrameStorage(frameCache, detectDeviceProfile()),
      startStartupBehaviors(),
      startLoopController(),
      startPreloader(),
      startAutoRefresh(),
      startUrlSync(),
    ];
    return () => stops.forEach((stop) => stop());
  }, []);
}
